import { canadaTopBarData } from "../../data/canadaTaxData";

export const CanadaTopBar = () => {
  const deadline = new Date("2026-04-30");
  const daysLeft = Math.ceil((deadline - new Date()) / (1000 * 60 * 60 * 24));

  return (
    <div className="bg-[#C8283A] text-white text-center py-2.5 px-4 text-xs sm:text-sm font-semibold tracking-wide" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
      Canada Tax Filing Deadline:{" "}
      <strong className="font-black">April 30, 2026</strong>
      <span className="ml-2 bg-[#D4A843] text-[#0B1829] text-xs font-black px-2.5 py-0.5 rounded-full uppercase tracking-widest">
        {daysLeft} Days Left
      </span>
    </div>
  );
};
